import commandEngine from './CommandEngine.js';
import jxWindowManager from '../../../../../JxControls/JxWindowManager/JxWindowManager.jsx';

/**
 * Registers the /countdown command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /countdown <minutes> <description> — opens a countdown timer, autostarts
 * e.g. /countdown 45 koken!
 */
export function registerCountdownCommand() {
    commandEngine.register('/countdown', {
        hint: 'Open countdown',
        params: [
            { name: 'minutes', hint: '<minutes>' },
            { name: 'description', hint: '<description>' },
        ],
        handler: (params) => {
            const [minutesStr, ...rest] = params;
            const minutes = parseFloat(minutesStr);
            if (!minutesStr || Number.isNaN(minutes)) return; // invalid input, silently ignore

            const description = rest.join(' ');
            jxWindowManager.openWindow('JxCountdownForm', 'global', { totalMs: minutes * 60000, description, autoStart: true }, true);
        },
    });
}
